import WhatshotRoundedIcon from '@mui/icons-material/WhatshotRounded';
import whatsNewList from './whatsNewList';
const WhatsNewListModule = {
    list: whatsNewList,
    icon: WhatshotRoundedIcon,
}; export default WhatsNewListModule;